var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.statusView.labelView,{tag:"component",staticClass:"default-status-view"},[_vm._v("\n  "+_vm._s(_vm.statusView.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }